// extracted by mini-css-extract-plugin
export var fullGrid = "_2s-3";
export var pdpPreviewContainer = "_2s-1";
export var previewContainer = "_2s-0";
export var togglePreviewContainer = "_2s-2";